import React from 'react'
import Tab from 'react-toolbox/lib/tabs/Tab'
import Tabs from 'react-toolbox/lib/tabs/Tabs'

import {NoiseChart} from './NoiseChart'
import {LineChart} from './LineChart'
import '../../../assets/react-toolbox/theme.css';
import theme from '../../../assets/react-toolbox/theme.js';
import ThemeProvider from 'react-toolbox/lib/ThemeProvider';

let index = 0;

export const GraphPanel = props => {

    const disabledAQI = (props.aqiMessages && props.aqiXAxis) || props.isDisabled;
    const disabledNoise = (props.noiseMessages && props.noiseXAxis) || props.noiseChart;
    const tabIndex = props.IoTsensor ? index : 0;

    return(
        <ThemeProvider theme={theme}>
            <div>
                <section>
                    <Tabs index={tabIndex} onChange={ i => index = i} fixed>
                        <Tab label="AQI" disabled={!disabledAQI}>
                            <LineChart
                                messages={props.aqiMessages}
                                xAxis={props.aqiXAxis}
                            />
                        </Tab>
                        <Tab label="NOISE" disabled={!disabledNoise}>
                            <NoiseChart
                                messages={props.noiseMessages}
                                xAxis={props.noiseXAxis}
                            />
                        </Tab>
                    </Tabs>
                </section>
            </div>
        </ThemeProvider>
    )
};


// WEBPACK FOOTER //
// ./src/components/Map/Common/GraphPanel.js